export default __webpack_public_path__ + "static/media/trampapo_01-03.abefe0c1.jpg";